export default __webpack_public_path__ + "static/media/support_avatar2.33599da1.png";